import React from "react";
import { FaFingerprint, FaUserLock, FaDoorClosed } from "react-icons/fa6";
import banner8 from "../assets/banner8.jpg";

export default function BiometricAccess() {
  const features = [
    { icon: <FaFingerprint size={20} className="text-primary" />, text: "Secure authentication via fingerprint, facial, or iris recognition." },
    { icon: <FaUserLock size={20} className="text-primary" />, text: "Controlled access to facilities with audit trail logging." },
    { icon: <FaDoorClosed size={20} className="text-primary" />, text: "Enhanced physical security for sensitive areas." },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">Biometric Access Control System</h2>
          <p className="section-copy">
            Deployment of secure biometric authentication solutions to control physical access, enhance security, and maintain audit trails.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner8} alt="Biometric Access Control" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Advanced authentication solutions ensure only authorized personnel gain access, protecting facilities and sensitive information.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map(item => (
              <li key={item.text} className="detail-feature-item">{item.icon}<span>{item.text}</span></li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Install biometric readers and configure devices for each access point.</li>
            <li>Register authorized users and assign access levels.</li>
            <li>Monitor access logs and generate security reports.</li>
            <li>Maintain hardware and software for ongoing security compliance.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}